import {useState,useRef,useEffect} from 'react';
import Link from 'next/link';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import styles from './../../../css/pc/login/login.module.scss';
import Nopwd_PC from './nopwd';
import Pwd_PC from './pwd';
import Reset_PC from './reset';
import ThirdBindModal_PC from './thirdBindModal';
import { ToastContainer,toast ,Zoom} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {QQLogin,weixinLogin,weiboLogin,jsonpSso,getAreaCode} from './../../../service/loginService';
import {useRouter} from 'next/router';
import Cookies from 'js-cookie';
import {Maps} from '@/js/prefix.js';

const Login_PC=({flag})=>{

    try{
        const DEFAULT_PREFIX = "中国+86";
        const validPrefixes = new Set(Maps.map(item => item.value));
        const router=useRouter();
        const returnUrl=router.query.returnUrl?router.query.returnUrl:'https://www.fx168news.com';
        const sourceCode=router.query.sourceCode;
        const [status, setStatus] = useState('login');
        const [sourceStatus, setSourceStatus] = useState('phone');
        const [tabIndex, setTabIndex] = useState(0);
        const [modalIsOpen, setIsOpen] = useState(false);
        const [ustr, setUstr] = useState('');
        const [prefix, setPrefix] = useState(DEFAULT_PREFIX);

        useEffect(()=>{
            loadPrefix();
        },[])

        useEffect(()=>{
            if(router.query.block){
                setStatus('reset');
            }
        },[router.query.block])

        const loadPrefix = async () => {
            const localPrefix = localStorage.getItem("countryPrefix");

            if (localPrefix && validPrefixes.has(localPrefix)) {
                setPrefix(localPrefix);
                return;
            }

            // 开始请求，同时设置超时为 5 秒
            const timeoutPromise = new Promise(resolve => {
                setTimeout(() => resolve(DEFAULT_PREFIX), 5000);
            });

            const fetchPromise = getAreaCode().then((res) => {
                if (res.code === 0 && validPrefixes.has(res.data)) {
                    localStorage.setItem("countryPrefix", res.data);
                    return res.data;
                }
                return DEFAULT_PREFIX;
            }).catch(() => DEFAULT_PREFIX);

            const result = await Promise.race([timeoutPromise, fetchPromise]);
            setPrefix(result);
        };
        const closeBind=()=>{
            setIsOpen(false);
        }
        //单点登录设置
        const handleSSO=(list)=>{
            for(let i=0;i<list.length;i++){
                /*
                $.ajax({
                    type:'get',
                    dataType:'jsonp',
                    url:list[i],
                    crossDomain:true,
                    success:function(){

                    }
                })  
                */
                // jsonpSso(list[i]);
            }
        }
        const toLogin=async(type,returnUrl)=>{
            //以下为按钮点击事件的逻辑。注意这里要重新打开窗口
            //否则后面跳转到QQ登录，授权页面时会直接缩小当前浏览器的窗口，而不是打开新窗口
            window.open(type,"ThirdLogin","width=450,height=450,menubar=0,scrollbars=1,resizable=1,status=1,titlebar=0,toolbar=0,location=1,top="+(window.screen.height-480)/2+",left="+(window.screen.width-460)/2);
            window.addEventListener('message', function (e) {
                if(e.data.hasOwnProperty('code')){
                    if(e.data.code==0){
                        if(e.data.isNeedBindMobile=='true'){
                            setUstr(e.data.u);
                            setIsOpen(true);
                        }else{
                            toast.success("登录成功！",{toastId:'customId'});
                            Cookies.set('t',e.data.t,{expires:7,path:'/',domain:document.domain.split('.').slice(-2).join('.'),secure:true});
                            handleSSO(e.data.sso);
                            if(returnUrl){
                                setTimeout(function(){location.href=returnUrl},1000);
                            }
                        }
                    }else{
                        toast.error( e.data.errorMessage||"登录失败！",{toastId:'customId'});
                    }
                }
            }, false)
        }

        return (
            <div className={styles.wrap} id="app">

                <style>{`
                    .react-tabs__tab--selected{
                        border-bottom:3px #327df2 solid;
                    }
                `}</style>
                <div className={styles.loginBoxWrap}>
                    <div className={styles.loginBox}>
                        {status=='login'?<Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
                            <TabList className={styles.tablist}>
                                <Tab>免密登录</Tab>
                                <Tab>密码登录</Tab>
                            </TabList>
                            <TabPanel>
                                <Nopwd_PC flag={flag} prefix={prefix} setPrefix={setPrefix} />
                            </TabPanel>
                            <TabPanel>
                                <Pwd_PC params={{setStatus:setStatus,sourceStatus:sourceStatus,setSourceStatus:setSourceStatus}} flag={flag} prefix={prefix} setPrefix={setPrefix} />
                            </TabPanel>
                        </Tabs>:<Reset_PC params={{setStatus:setStatus,sourceStatus:sourceStatus}} flag={flag} prefix={prefix} setPrefix={setPrefix} />}
                        
                        <div className={styles.socialTitleItem}><b></b><span>社交账号登录</span><b></b></div>
                        <div className={styles.socialItem}>
                            <a className={styles.weixin} onClick={()=>{toLogin(weixinLogin+'?type=1',returnUrl)}}>微信</a>
                            <a className={styles.qq} onClick={()=>{toLogin(QQLogin+'?type=1',returnUrl)}}>QQ</a>
                            <a className={styles.weibo} onClick={()=>{toLogin(weiboLogin+'?type=1',returnUrl)}}>微博</a>
                        </div>
                        <div className={styles.kefuItem}>登录遇到问题，进入<Link href="https://kf.168cjw.com/chat.html"><a target="_blank">人工客服</a></Link></div>
                    </div>
                </div>
                <ThirdBindModal_PC params={{modalIsOpen:modalIsOpen,setIsOpen:setIsOpen,closeBind:closeBind,ustr:ustr}} flag={flag} prefix={prefix} setPrefix={setPrefix} />
                <ToastContainer 
                    closeButton={false} 
                    position="top-center"
                    autoClose= {2000}
                    hideProgressBar={true}
                    closeOnClick={true}
                    pauseOnHover={false}
                    draggable={false}
                    progress={0}
                    delay={10}
                    transition={Zoom}
                    className={styles.toast}
                />
                <div id="captcha"></div>
                <div id="captcha2"></div>
                <div id="captcha3"></div>
            </div>
        );
    }catch(e){
        console.log(e);
        return null;
    } 
};

export default Login_PC;
